
import { defineComponent, PropType } from '@vue/runtime-core'

export interface Definition {
  dt: string
  dd: string | number
  unit?: string
}

export default defineComponent({
  props: {
    items: {
      type: Array as PropType<Definition[]>
    }
  }
})
